import { render, staticRenderFns } from "./SwiperSlideArrows.vue?vue&type=template&id=31be2d4a"
import script from "./SwiperSlideArrows.vue?vue&type=script&lang=js"
export * from "./SwiperSlideArrows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports